export const NOTIFY_LOCALE_ZHCHT = {
    title: 'ä¿çµ±æç¤º'
};
